import React from "react";
import {
  Button,
  Col,
  Grid,
  Row,
  Table,
  FormGroup,
  ControlLabel,
  FormControl,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Axios from "axios";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card";
import Datetime from "react-datetime";
import Select from "react-select";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import {
  createOrder,
  getAllMedication,
  getAllmedicationDataByBatchNumber,
  getBatchNumberByMedicine,
  getStoreWise,
  searchMedicationForPurchaseOrder,
  // createOrder,
} from "../../../Listfunction";
import {
  createPurchaseRequest,
  PurchaseRequestMedicationCheck,
} from "../../../api/purchaseRequest/purchaseRequest";
import {
  // AddWarehouseInventoryDispatchAPI,
  getAllStoresByCountryCode,
} from "../../../api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/lib/Async";
import { searchMedicationForOrder } from "api/purchaseOrder/PurchaseOrder";
import CheckAvailablePr from "./CheckAvailablePr";

const AddPurchaseRequestForm = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  // const _notificationSystem = useRef(null);
  const _notificationSystem = useRef(null);
  const [storeOptions, setStoreOptions] = useState([]);
  const [store, setStore] = useState([]);
  const [selectRequestDate, setSelectRequestDate] = useState(new Date());
  const [enterReference, setEnterReference] = useState("");
  const [getMedicine, setGetMedicine] = useState("");
  const [medications, setMedications] = useState([]);
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState({ id: null });
  const [storeIDError, setStoreIDError] = useState(null);
  const [userStore_id, getUserStore_id] = useState();
  const [role, setRole] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [localMedicationData, setLocalMedicationData] = useState([]);
  const [medicationOptions, setMedicationOptions] = useState([]);
  const medIndexRef = useRef([]);
  const medMapRef = useRef({});
  const medSearchCacheRef = useRef({});
  const medSearchRequestSeqRef = useRef(0);
  const loadMedTimerRef = useRef(null);
  const [activePRItems, setActivePRItems] = useState([]);
  const [showPrModal, setShowPrModal] = useState(false);
  const [selectedPrItems, setSelectedPrItems] = useState([]);
  const [getPrId, setGetPrId] = useState("");
  const [getOrder_id, setGetOrder_id] = useState("");
  const [selectStoreWise, setSelectStoreWise] = useState([]);
  const [getStore, setGetStore] = useState("");
  const batchInputRef = useRef([]);

  // Local draft persistence key
  const DRAFT_KEY = "addPurchaseRequestDraft";
  const [draftRestored, setDraftRestored] = useState(false);
  // Save current form state to localStorage (simple snapshot)
  const saveDraft = () => {
    try {
      const draft = {
        selectRequestDate,
        enterReference,
        store,
        rows,
        // timestamp to help determine recency when debugging/merging
        lastModified: Date.now(),
      };
      localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch (e) {
      // ignore storage errors (quota, private mode etc.)
      console.warn("Failed to save Purchase Request draft:", e);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role) {
      setRole(user.role);
    }
    getStoreList();
    getUser();
    fetchAllStores();
    try {
      handleGetAllMedication();
    } catch (e) {
      // ignore errors during initial prefetch
    }
    // Restore draft from localStorage on mount
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (raw) {
        const d = JSON.parse(raw);
        // Restore primitive / serializable pieces
        if (d.selectRequestDate) setSelectRequestDate(d.selectRequestDate);
        if (d.enterReference) setEnterReference(d.enterReference);
        if (d.store) setStore(d.store);
        if (d.rows) setRows(d.rows);
        if (d.rows) onChangeMedicineCheck(d.rows);
        // mark restored so later initialization won't overwrite saved rows
        setDraftRestored(true);
      }
    } catch (e) {
      console.warn("Failed to restore Purchase Request draft:", e);
    }
  }, []);

  // Autosave draft whenever important pieces change
  useEffect(() => {
    // throttle-less immediate save is fine for this form
    saveDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRequestDate, enterReference, store, rows]);

  const getStoreList = () => {
    getStoreWise(token.country_code, obj).then((res) => {
      const store = res.data || [];
      const storeLists = store.map((store) => ({
        value: store.id,
        label: store.name,
      }));
      console.log(storeLists, "storeLists");
      setSelectStoreWise(storeLists);

      const flashWarehouseDefault =
        storeLists.find((item) => Number(item.value) === 11) ||
        storeLists.find((item) =>
          String(item.label || "")
            .toLowerCase()
            .includes("flash warehouse"),
        ) ||
        null;

      if (!getStore && flashWarehouseDefault) {
        setGetStore(flashWarehouseDefault);
      }
    });
  };

  const getUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      setUserData({ id: user.id });
      getUserStore_id(user.store_id);
    }
  };
  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setStoreOptions(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  const handleInputChange = (inputValue) => {
    setGetMedicine(inputValue);

    if (inputValue.trim() !== "") {
      searchMedicationForPurchaseOrder(inputValue, obj)
        .then((res) => {
          if (res.success) {
            const selectedIds = rows
              .filter((row) => row.selectedOption)
              .map((row) => row.selectedOption.value);
            const options = res.data.data
              .filter((med) => !selectedIds.includes(med.id))
              .map((med) => ({
                value: med.id,
                label: `${med.medication_name} (${med.item_code})`,
                data: med,
                qty: med.total_quantity - med.total_allocated,
              }));
            setMedications(options);
          }
        })
        .catch((err) => {
          console.error("Error fetching medications", err);
        });
    } else {
      setMedications([]);
    }
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        batch_no: "",
        selectedOption: null,
        availableStock: "0",
        qty: "1",
      },
    ]);
  };

  const handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = 1;
    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        // this.setState({ allMedicine: mdata });
        const medicationOptions = mdata.map((medication) => ({
          value: medication.id,
          label: `${medication.title} (${medication.item_code})`,
        }));
        setMedicationOptions(medicationOptions);
        // store local medication data and build a local index for fast
        // client-side lookups (functional component style)
        setLocalMedicationData(mdata);
        if (mdata && mdata.length > 0) {
          buildMedIndex(mdata);
        }
      });
  };

  // Build a simple phonetic code for loose matching (used by buildMedIndex)
  const soundex = (str) => {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    return out.padEnd(4, "0").slice(0, 4);
  };

  const buildMedIndex = (medArray) => {
    try {
      medIndexRef.current = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      medIndexRef.current.sort((a, b) =>
        a.labelLower > b.labelLower ? 1 : -1,
      );

      // build map for quick access to full medication objects
      const map = {};
      medArray.forEach((m) => {
        map[m.id] = m;
      });
      medMapRef.current = map;
    } catch (e) {
      medIndexRef.current = [];
      medMapRef.current = {};
    }
  };

  // async loader for medication select with debounce + cache + request sequencing
  const loadMedicationOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);

    const q = inputValue.trim();

    // return cached result when available
    if (medSearchCacheRef.current[q]) {
      return Promise.resolve(medSearchCacheRef.current[q]);
    }

    // ensure medIndex is built from localMedicationData when available
    if (
      (!medIndexRef.current || medIndexRef.current.length === 0) &&
      localMedicationData &&
      localMedicationData.length > 0
    ) {
      buildMedIndex(localMedicationData);
    }

    return new Promise((resolve) => {
      if (loadMedTimerRef.current) clearTimeout(loadMedTimerRef.current);
      loadMedTimerRef.current = setTimeout(() => {
        // If we have local data index, filter locally (fast)
        if (medIndexRef.current && medIndexRef.current.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          // 1) prefix matches
          for (
            let i = 0;
            i < medIndexRef.current.length && results.length < LIMIT;
            i++
          ) {
            const m = medIndexRef.current[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          // 2) substring matches
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          // 3) phonetic soundex fallback for longer queries
          if (results.length === 0 && lower.length >= 3) {
            const qSound = soundex(lower);
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));

          // cache limited queries
          try {
            const keys = Object.keys(medSearchCacheRef.current);
            if (keys.length > 200) delete medSearchCacheRef.current[keys[0]];
            medSearchCacheRef.current[q] = options;
          } catch (e) {}

          return resolve(options);
        }

        // fallback: call API once (debounced) if no local data
        medSearchRequestSeqRef.current++;
        const reqSeq = medSearchRequestSeqRef.current;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const auth = token ? token.token : null;
          const store_id = userStore_id;
          const city_id = 1;

          searchMedicationForOrder(q, city_id, 1, auth, store_id)
            .then((res) => {
              if (reqSeq !== medSearchRequestSeqRef.current) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: Number(medication.id || medication.medication_id),
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(medSearchCacheRef.current);
                if (keys.length > 200)
                  delete medSearchCacheRef.current[keys[0]];
                medSearchCacheRef.current[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };
  // const moveToDispatchItems = async (getPrId) => {
  //   const data = {
  //     dispatch_date: moment(selectRequestDate).format("YYYY-MM-DD"),
  //     dispatch_by: token.id,
  //     medications: rows.map((row) => ({
  //       medication_id: !!row.selectedOption ? row.selectedOption.value : null,
  //       quantity: parseInt(row.qty),
  //     })),
  //     purchase_request_id: getPrId,
  //     store_id: getStore && getStore.value,
  //   };
  //   const res = await AddWarehouseInventoryDispatchAPI(data, obj);
  //   if (!!res.data.success) {
  //     _notificationSystem.current.addNotification({
  //       message: "Warehouse Inventory Dispatch submitted successfully!",
  //       level: "success",
  //     });
  //   } else {
  //     _notificationSystem.current.addNotification({
  //       message: "Failed to submit Warehouse Inventory Dispatch.",
  //       level: "error",
  //     });
  //   }
  // };

  // const onCreateOrder = async (getPrId) => {
  //   const isProduction =
  //     !process.env.REACT_APP_NOT_SECRET_CODE.includes("staging");
  //   const notification = _notificationSystem.current;
  //   const orderPayload = {
  //     lead_id: isProduction ? "75381" : "8239",
  //     source: "1",
  //     order_date: moment().format("YYYY-MM-DD"),
  //     delivery_type: "1",
  //     address_id: isProduction ? 18783 : 6241,
  //     city: "4",
  //     country_id: "1",
  //     channel: "admin",
  //     medications: rows
  //       .filter((row) => row && row.selectedOption && row && row.qty)
  //       .map((row) => ({
  //         id: Number(row.selectedOption.value),
  //         quantity: Number(row.qty),
  //         unit_price: Number(row.selectedOption.price),
  //         margin_discount_percentage: 0,
  //         margin_discount_price: 0,
  //         claimable: false,
  //         is_printable: false,
  //       })),
  //     paymentoption: "Cash",
  //     order_status: "1",
  //     margin_type: "1",
  //     margin: 0,
  //     order_sub_type: "4",
  //     store_id: 1,
  //     delivery_charge: 0,
  //     payment_due_date: moment().format("YYYY-MM-DD"),
  //     pr_id: getPrId,
  //   };
  //   try {
  //     const res = await createOrder(obj, orderPayload);
  //     setGetOrder_id(res.data.data.id);
  //     if (!notification) {
  //       return;
  //     }
  //     if (res && res.data.success) {
  //       notification.addNotification({
  //         title: <span data-notify="icon" className="pe-7s-gift" />,
  //         message: (
  //           <div>
  //             <b>Order</b> Created Successfully.
  //           </div>
  //         ),
  //         level: "success",
  //         position: "bl",
  //         autoDismiss: 15,
  //       });
  //     } else {
  //       notification.addNotification({
  //         title: <span data-notify="icon" className="pe-7s-gift" />,
  //         message: (
  //           <div>
  //             <b>Error:</b> {(res && res.data.message) || "Failed to add order"}
  //           </div>
  //         ),
  //         level: "error",
  //         position: "bl",
  //         autoDismiss: 15,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Create order failed:", error);

  //     if (notification) {
  //       notification.addNotification({
  //         title: <span data-notify="icon" className="pe-7s-gift" />,
  //         message: (
  //           <div>
  //             <b>Network Error:</b> Please try again.
  //           </div>
  //         ),
  //         level: "error",
  //         position: "bl",
  //         autoDismiss: 15,
  //       });
  //     }
  //   }
  // };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleSelectChange = async (
    selectedOption,
    index,
    sourceRows = rows,
  ) => {
    if (!selectedOption) return;

    const selectedStoreId =
      getStore && getStore.value ? Number(getStore.value) : null;
    if (!selectedStoreId) {
      setStoreIDError(
        <small className="text-danger">warehouse is required</small>,
      );
      await Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Please select warehouse first</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const updatedRows = [...sourceRows];
    updatedRows[index] = {
      ...updatedRows[index],
      selectedOption: selectedOption,
    };

    const selectedMedData =
      localMedicationData &&
      localMedicationData.find((med) => med.id === selectedOption.value);

    const currentRow =
      updatedRows && updatedRows[index] ? updatedRows[index] : {};
    const currentBatchNo = currentRow.batch_no
      ? String(currentRow.batch_no).trim()
      : "";
    const selectedMediId =
      currentRow && currentRow.selectedOption && currentRow.selectedOption.value
        ? Number(currentRow.selectedOption.value)
        : Number(selectedOption.value);

    let availableStockFromApi = 0;
    let warehouseStockFromApi = null;
    let pharmacyStockFromApi = 0;
    let matchedBatch = null;
    if (selectedMediId) {
      try {
        const batchRes = await getAllmedicationDataByBatchNumber(
          obj,
          currentBatchNo || "",
          selectedMediId,
        );

        const batchList =
          batchRes && batchRes.data && Array.isArray(batchRes.data.data)
            ? batchRes.data.data
            : [];

        const storeFiltered = selectedStoreId
          ? batchList.filter(
              (item) => Number(item.store_id) === Number(selectedStoreId),
            )
          : batchList;

        const pharmacyFiltered = userStore_id
          ? batchList.filter(
              (item) => Number(item.store_id) === Number(userStore_id),
            )
          : [];

        matchedBatch =
          (currentBatchNo
            ? storeFiltered.find(
                (item) =>
                  String(item && item.batch_no ? item.batch_no : "") ===
                  currentBatchNo,
              )
            : null) ||
          storeFiltered[0] ||
          batchList[0] ||
          null;

        availableStockFromApi = matchedBatch
          ? Number(matchedBatch.quantity || 0)
          : 0;

        if (matchedBatch) {
          const storeWiseMedications = Array.isArray(
            matchedBatch.store_wise_medication,
          )
            ? matchedBatch.store_wise_medication
            : Array.isArray(matchedBatch.store_medication_all)
              ? matchedBatch.store_medication_all
              : [];

          if (storeWiseMedications.length > 0) {
            const selectedWarehouseMedication =
              storeWiseMedications.find(
                (item) => Number(item.store_id) === Number(selectedStoreId),
              ) || null;

            if (selectedWarehouseMedication) {
              warehouseStockFromApi = Number(
                selectedWarehouseMedication.quantity || 0,
              );
            }

            const pharmacyMedication =
              storeWiseMedications.find(
                (item) => Number(item.store_id) === Number(userStore_id),
              ) ||
              storeWiseMedications.find(
                (item) =>
                  item &&
                  item.pharmacies &&
                  String(item.pharmacies.type || "").toLowerCase() ===
                    "pharmacy",
              ) ||
              null;

            pharmacyStockFromApi = pharmacyMedication
              ? Number(pharmacyMedication.quantity || 0)
              : 0;
          }
        }

        if (pharmacyFiltered.length > 0) {
          pharmacyStockFromApi = Number(pharmacyFiltered[0].quantity || 0);
        }
      } catch (e) {
        console.warn("Failed to fetch available stock:", e);
      }
    }

    const selectedOptionWithQty = {
      ...selectedOption,
      qty:
        warehouseStockFromApi !== null
          ? warehouseStockFromApi
          : selectedOption && selectedOption.qty !== undefined
            ? Number(selectedOption.qty || 0)
            : selectedMedData
              ? availableStockFromApi ||
                selectedMedData.total_quantity - selectedMedData.total_allocated
              : Number(selectedOption.qty || 0),
    };

    const duplicate =
      updatedRows &&
      updatedRows.some(
        (row, i) =>
          i !== index &&
          row.selectedOption &&
          row.selectedOption.value === selectedOption.value,
      );

    if (duplicate) {
      Swal.fire({
        width: " 478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>This medicine is already selected in another row!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      setRows((prevRows) => {
        const updatedRows = [...prevRows];
        if (updatedRows[index]) {
          updatedRows[index] = {
            ...updatedRows[index],
            batch_no: "",
          };
        }
        return updatedRows;
      });
      return;
    }

    if (matchedBatch && !currentBatchNo) {
      updatedRows[index].batch_no = matchedBatch.batch_no || "";
    }

    updatedRows[index].selectedOption = selectedOptionWithQty;
    // updatedRows[index].selectedOption = {
    //   ...selectedOption,
    //   price: Number(selectedMedData.price),
    // };
    updatedRows[index].availableStock =
      selectedOption && selectedOption.pharmacyStock !== undefined
        ? Number(selectedOption.pharmacyStock || 0)
        : Number(pharmacyStockFromApi || 0);
    setRows(updatedRows);
    onChangeMedicineCheck(updatedRows, selectedMediId);
  };

  const handleBatchInputChange = (event, index) => {
    const value = event.target.value;
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      batch_no: value,
    };
    setRows(updatedRows);
  };

  const handleBatchNumber = async (batchNo, index) => {
    const value = String(batchNo || "").trim();
    if (!value) return;

    try {
      const selectedStoreId =
        getStore && getStore.value ? Number(getStore.value) : null;

      if (!selectedStoreId) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Please select warehouse first</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const currentRow = rows && rows[index] ? rows[index] : {};
      const currentMedId =
        currentRow &&
        currentRow.selectedOption &&
        currentRow.selectedOption.value
          ? Number(currentRow.selectedOption.value)
          : null;

      let list = [];

      if (currentMedId) {
        const batchByMed = await getAllmedicationDataByBatchNumber(
          obj,
          value,
          currentMedId,
        );
        list =
          batchByMed && batchByMed.data && Array.isArray(batchByMed.data.data)
            ? batchByMed.data.data
            : [];
      }

      if (!list.length) {
        const response = await getBatchNumberByMedicine(obj, value);
        const data = response && response.data ? response.data.data : null;
        list = Array.isArray(data) ? data : [];
      }

      const storeFiltered = selectedStoreId
        ? list.filter(
            (item) => Number(item.store_id) === Number(selectedStoreId),
          )
        : list;

      const medFiltered = currentMedId
        ? storeFiltered.filter(
            (item) => Number(item.medication_id) === Number(currentMedId),
          )
        : storeFiltered;

      const medicineDetails =
        medFiltered.find(
          (item) =>
            String(item && item.batch_no ? item.batch_no : "").toLowerCase() ===
            value.toLowerCase(),
        ) ||
        medFiltered[0] ||
        null;

      if (!medicineDetails) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });

        setRows((prevRows) => {
          const updatedRows = [...prevRows];
          if (updatedRows[index]) {
            updatedRows[index] = {
              ...updatedRows[index],
              batch_no: "",
            };
          }
          return updatedRows;
        });
        return;
      }

      const resolvedMedId = Number(
        medicineDetails.medication_id || currentMedId || 0,
      );
      const medFromLocal =
        localMedicationData &&
        localMedicationData.find((medItem) => medItem.id === resolvedMedId);
      const storeMedicationAll =
        medicineDetails.store_medication_all &&
        medicineDetails.store_medication_all.length > 0
          ? medicineDetails.store_medication_all
          : [];

      const warehouseStoreMedication =
        storeMedicationAll.find(
          (item) => Number(item.store_id) === Number(selectedStoreId),
        ) ||
        storeMedicationAll[0] ||
        null;

      const pharmacyStoreMedication =
        storeMedicationAll.find(
          (item) => Number(item.store_id) === Number(userStore_id),
        ) ||
        storeMedicationAll.find(
          (item) =>
            item &&
            item.pharmacies &&
            String(item.pharmacies.type || "").toLowerCase() === "pharmacy",
        ) ||
        null;

      const medTitle =
        (warehouseStoreMedication &&
          warehouseStoreMedication.medication_title) ||
        (medFromLocal &&
          (medFromLocal.title || medFromLocal.medication_name)) ||
        "Medicine";
      const medItemCode =
        (warehouseStoreMedication && warehouseStoreMedication.item_code) ||
        (medFromLocal && medFromLocal.item_code) ||
        medicineDetails.item_code ||
        "";

      const warehouseQty = Number(
        (warehouseStoreMedication && warehouseStoreMedication.quantity) ||
          medicineDetails.quantity ||
          0,
      );
      const pharmacyQty = Number(
        (pharmacyStoreMedication && pharmacyStoreMedication.quantity) || 0,
      );

      const selectedOption = {
        value: resolvedMedId,
        label: medTitle + " (" + medItemCode + ")",
        batch_no: value,
        qty: warehouseQty,
        pharmacyStock: pharmacyQty,
      };

      if (!selectedOption.value) {
        await Swal.fire({
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Batch not found</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const updatedRows = [...rows];
      updatedRows[index] = {
        ...updatedRows[index],
        batch_no: value,
        availableStock: pharmacyQty,
      };

      await handleSelectChange(selectedOption, index, updatedRows);
    } catch (error) {
      Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Unable to Find batch</div>",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    }
  };

  const handleBatchNoEnter = async (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      await handleBatchNumber(event.target.value, index);
    }
  };
  const handleViewPr = (medicationId) => {
    if (!medicationId) return;
    const selectedRow = rows.find(
      (row) => row.selectedOption && row.selectedOption.value === medicationId,
    );
    const medicineName =
      (selectedRow.selectedOption && selectedRow.selectedOption.label) || "—";
    const filteredItems = activePRItems
      .filter((item) => item.medication_id === medicationId)
      .map((item) => ({
        ...item,
        medicine_name: medicineName,
      }));
    setSelectedPrItems(filteredItems);
    setShowPrModal(true);
  };

  const handleQtyChange = (e, index) => {
    const value = e.target.value;
    const updatedRows = [...rows];
    updatedRows[index].qty = value;
    updatedRows[index].touched = true;
    setRows(updatedRows);
  };

  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }

    const updatedRows = [...rows];
    updatedRows[index].qty = value.toString();
    setRows(updatedRows);
  };

  const setBatchInputRef = (el, index) => {
    if (!batchInputRef.current) batchInputRef.current = [];
    batchInputRef.current[index] = el;
  };

  useEffect(() => {
    if (Number(role) !== 11) return;
    if (!Array.isArray(rows) || rows.length === 0) return;

    const firstEmptyBatchIndex = rows.findIndex(
      (row) => !String((row && row.batch_no) || "").trim(),
    );
    const targetIndex = firstEmptyBatchIndex >= 0 ? firstEmptyBatchIndex : 0;
    const targetInput =
      batchInputRef.current[targetIndex] || batchInputRef.current[0];

    if (!targetInput) return;

    setTimeout(() => {
      try {
        targetInput.focus();
      } catch (e) {}
    }, 0);
  }, [role, rows.length]);

  const referenceOnChange = (event) => {
    const reference = event.target.value;
    setEnterReference(reference);
  };

  const handleRequestDate = (value) => {
    setSelectRequestDate(value);
  };

  const validateRequestDate = (current) => {
    return current.isSameOrAfter(moment(), "day");
  };
  const getPurchaseRequestIds = (medicationId) => {
    if (!medicationId || !activePRItems) return [];
    return activePRItems
      .filter((item) => item.medication_id === medicationId)
      .map((item) => item.purchase_request_id);
  };

  const onChangeMedicineCheck = (rowsData, selectedMediId = null) => {
    let medicationsPayload = rowsData
      .filter((row) => row && row.selectedOption && row.selectedOption.value)
      .map((row) => Number(row.selectedOption.value))
      .filter((id) => !Number.isNaN(id))
      .map((id) => ({ id }));

    const selectedId = Number(selectedMediId);
    if (!Number.isNaN(selectedId)) {
      const alreadyExists = medicationsPayload.some(
        (item) => item.id === selectedId,
      );
      if (!alreadyExists) {
        medicationsPayload.unshift({ id: selectedId });
      }
    }

    const mediId = {
      medications: medicationsPayload,
    };
    PurchaseRequestMedicationCheck(obj, mediId)
      .then((response) => {
        const items = (response.data && response.data.items) || [];
        setActivePRItems(items);
      })
      .catch((error) => {
        console.error("Failed to fetch active PR items:", error);
        setActivePRItems([]);
      });
  };

  const onSubmit = async () => {
    const notification = _notificationSystem.current;
    let error = false;

    const hasPreviousPR = rows.some(
      (row) =>
        row.selectedOption &&
        getPurchaseRequestIds(row.selectedOption && row.selectedOption.value)
          .length > 0,
    );

    if (!getStore || !getStore.value) {
      error = true;
      setStoreIDError(
        <small className="text-danger">warehouse is required</small>,
      );
      return;
    }
    for (const row of rows) {
      if (!row.qty || row.qty <= 0) {
        Swal.fire({
          width: "500px",
          title:
            "<div style='font-size:34px; font-weight:bold;'>Quantity Required</div>",
          icon: "warning",
          html: "<div style='font-size:15px;'>Please enter a valid quantity for all medicines.</div>",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }
    }
    if (rows.length === 0) {
      Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>Please Enter Proper Medication data!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    const isAnyRowIncomplete = rows.some(
      (row) => !row.selectedOption || !row.selectedOption.value,
    );

    if (isAnyRowIncomplete) {
      Swal.fire({
        width: "478",
        title:
          "<div style='font-size:26px;font-weight: 100;'>Please Enter Proper Medication data!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    if (isSubmitting) return;
    if (hasPreviousPR) {
      const result = await Swal.fire({
        width: "520px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Do you want to continue?</div>",
        html: "<div style='font-size:16px;'>Some selected medicines are already included in previous incomplete Refill requests</div>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "<span style='font-size:18px;'>Yes</span>",
        cancelButtonText: "<span style='font-size:18px;'>No</span>",
        allowOutsideClick: false,
        showCloseButton: true,
      });

      if (!result.isConfirmed) {
        return;
      }
    }
    setIsSubmitting(true);

    const tagPayload = {
      reference: enterReference,
      request_date: selectRequestDate,
      status: "1",
      request_by: userData.id,
      medications: rows.map((row) => ({
        id: !!row.selectedOption ? row.selectedOption.value : null,
        quantity: parseInt(row.qty),
      })),
      store_id: role === 1 || role === null ? getStore : userStore_id,
    };

    createPurchaseRequest(obj, tagPayload)
      .then(async (res) => {
        if (res.data.success) {
          const prId = res.data.data.id;
          setGetPrId(prId);
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
              <div>
                <b>Purchase Request</b> Created Successfully.
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          // const orderRes = await onCreateOrder(prId);
          // const dispatched = await moveToDispatchItems(prId);
          // clear draft on successful submission
          try {
            localStorage.removeItem(DRAFT_KEY);
          } catch (e) {
            // ignore
          }
          setTimeout(() => {
            props.history.push("/admin/purchase-request");
          }, 3000);
        } else {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
              <div>
                <b>
                  Error: {res.data.message || "Failed to add purchase request"}
                </b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
          setIsSubmitting(false);
        }
      })

      .catch((error) => {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift" />,
          message: (
            <div>
              <b>Error: {error.message || "Something went wrong"}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
        setIsSubmitting(false);
      });
  };

  const inputRef = useRef(null);
  const setInputRef = (el, index) => {
    // initialize as an array so length checks and numeric indices work as expected
    if (!inputRef.current) {
      inputRef.current = [];
    }
    inputRef.current[index] = el;
    // Intentionally do not auto-focus on ref attachment. Focusing should only
    // happen when the user clicks 'Add' (handled in handleAddClick).
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Card
          tableFullWidth
          content={
            <div
              className="order_topdata_container"
              style={{
                marginBottom: "40px",
                padding: "0 20px",
              }}
            >
              <Row>
                <Col lg={12}>
                  {role === 1 || role === null ? (
                    <>
                      <Row>
                        <Col lg={4}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel>Request Date</ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{
                                  placeholder: "Request Date",
                                  disabled: true,
                                }}
                                isValidDate={validateRequestDate}
                                closeOnSelect={true}
                                value={selectRequestDate}
                                onChange={handleRequestDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg={4}>
                          <FormGroup>
                            <ControlLabel>Select warehouse</ControlLabel>
                            <Select
                              options={selectStoreWise}
                              value={getStore}
                              onChange={(selectedStore) => (
                                setGetStore(selectedStore || ""),
                                setStoreIDError(null)
                              )}
                              name="store"
                              placeholder="Select warehouse"
                            />
                            {storeIDError}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel>Reference</ControlLabel>
                              <textarea
                                maxLength={220}
                                className="form-control"
                                rows="4"
                                cols="5"
                                placeholder="Enter Reference"
                                onChange={referenceOnChange}
                                value={enterReference || ""}
                              ></textarea>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Row>
                      <Col lg={4}>
                        <FormGroup className="fl_datepicker">
                          <div className="payment_duePicker">
                            <ControlLabel>Request Date</ControlLabel>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{
                                placeholder: "Request Date",
                                disabled: true,
                              }}
                              isValidDate={validateRequestDate}
                              closeOnSelect={true}
                              value={selectRequestDate}
                              onChange={handleRequestDate}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg={4}>
                        <FormGroup className="fl_datepicker">
                          <div className="payment_duePicker">
                            <ControlLabel>Reference</ControlLabel>
                            <textarea
                              maxLength={220}
                              className="form-control"
                              rows="4"
                              cols="5"
                              placeholder="Enter Reference"
                              onChange={referenceOnChange}
                              value={enterReference || ""}
                            ></textarea>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Sr.No</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Batch No</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Medicine Name</ControlLabel>
                              </th>

                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Warehouse Stock</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Quantity</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>
                                  Previous Refill Orders
                                </ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={10}
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  No medication added
                                </td>
                              </tr>
                            ) : (
                              rows.map((row, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {index + 1}
                                  </td>
                                  <td>
                                    <FormControl
                                      type="text"
                                      name="batch_no"
                                      placeholder="Scan Batch No"
                                      inputRef={(el) =>
                                        setBatchInputRef(el, index)
                                      }
                                      value={row.batch_no || ""}
                                      onChange={(e) =>
                                        handleBatchInputChange(e, index)
                                      }
                                      onKeyDown={(e) =>
                                        handleBatchNoEnter(e, index)
                                      }
                                      // disabled
                                    />
                                  </td>
                                  <td style={{ width: "30%" }}>
                                    <AsyncSelect
                                      className="react-select primary"
                                      classNamePrefix="react-select"
                                      name="item"
                                      value={
                                        row.selectedOption &&
                                        row.selectedOption.label &&
                                        row.selectedOption.value
                                          ? row.selectedOption
                                          : null
                                      }
                                      onChange={(value) =>
                                        handleSelectChange(value, index)
                                      }
                                      loadOptions={loadMedicationOptions}
                                      cacheOptions
                                      defaultOptions={false}
                                      ref={(ref) => setInputRef(ref, index)}
                                      placeholder="Medication"
                                      noOptionsMessage={() =>
                                        "Type Item Name or Code or Barcode"
                                      }
                                    />
                                    {row.selectedOption &&
                                      getPurchaseRequestIds(
                                        row.selectedOption.value,
                                      ).length > 0 && (
                                        <p
                                          style={{
                                            marginLeft: "3px",
                                            fontSize: "12px",
                                            color: "red",
                                            marginBottom: "-16px",
                                          }}
                                        >
                                          Item already in previous incomplete
                                          Refill.
                                        </p>
                                      )}
                                  </td>
                                  <td>
                                    <FormControl
                                      isDisabled
                                      placeholder="Available Stock"
                                      value={
                                        row.selectedOption &&
                                        row.selectedOption.qty < 0
                                          ? 0
                                          : row.selectedOption &&
                                            row.selectedOption.qty
                                      }
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <>
                                      <FormControl
                                        name="qty"
                                        value={row.qty}
                                        type="number"
                                        min="1"
                                        placeholder="Enter Quantity"
                                        onBlur={(e) => handleQtyBlur(e, index)}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) =>
                                          handleQtyChange(e, index)
                                        }
                                      />
                                      {!!row.selectedOption &&
                                        userStore_id !== 1 &&
                                        userStore_id !== null && (
                                          <p
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "12px",
                                              color: "green",
                                              marginBottom: "-16px",
                                            }}
                                          >
                                            Pharmacy Stock {row.availableStock}
                                          </p>
                                        )}
                                    </>
                                  </td>
                                  <td>
                                    {" "}
                                    {row.selectedOption &&
                                      (() => {
                                        const prIds = getPurchaseRequestIds(
                                          row.selectedOption.value,
                                        );
                                        const prCount = prIds.length;
                                        return (
                                          prCount > 0 && (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-pr-${row.selectedOption && row.selectedOption.value}`}
                                                >
                                                  Kindly be informed that this
                                                  medicine appears in{" "}
                                                  <strong>{prCount}</strong>{" "}
                                                  previous purchase request(s)
                                                  which remain incomplete.
                                                </Tooltip>
                                              }
                                            >
                                              <Button
                                                size="sm"
                                                style={{ textAlign: "center" }}
                                                className="btn btn-danger"
                                                onClick={() =>
                                                  handleViewPr(
                                                    row.selectedOption.value,
                                                  )
                                                }
                                              >
                                                <strong>
                                                  View Refill Orders
                                                </strong>{" "}
                                                ({prCount})
                                              </Button>
                                            </OverlayTrigger>
                                          )
                                        );
                                      })()}
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      X
                                    </a>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                    <div style={{ textAlign: "center" }}>
                      <Button
                        className="btn btn-default"
                        style={{ marginTop: "15px" }}
                        onClick={handleAddRow}
                      >
                        <i className="fa fa-plus"></i> Add Medicine
                      </Button>
                    </div>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                <Col sm={12}>
                  <Button
                    style={{ marginBottom: "15px" }}
                    onClick={onSubmit}
                    disabled={isSubmitting}
                    className="fl_btn_add_order btn-fill btn btn-default"
                    fill="true"
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>{" "}
                </Col>
              </Row>
            </div>
          }
        />
        <CheckAvailablePr
          show={showPrModal}
          onHide={() => setShowPrModal(false)}
          items={selectedPrItems}
        />
      </Grid>
    </div>
  );
};

export default AddPurchaseRequestForm;
